export default {
  title: 'FLIGHT 404',
  tokenName: 'FLIGHT 404',
  description: 'FLIGHT 404 是 GGMOMOMO 品牌打造的多人社交推理遊戲。\n\n一架原本普通的航班，在起飛後逐漸失去控制。乘客之中隱藏著不同身份與目的，每個人都可能是你的盟友，也可能正在等待下一個下手機會。\n\n玩家需要透過觀察、討論、投票與角色能力尋找真相，在每一個航程階段作出選擇。滲透、欺騙、保護、襲擊與反制不斷交錯，而一次錯誤的判斷，就可能改變整架航班所有人的命運。\n\n在 FLIGHT 404，真正決定勝負的從來不只是你的身份，而是你能否讓其他人相信你所說的每一句話。\n\n登機之後，沒有人能確定誰會活著抵達終點。',
  status: '開發中',
  openInfo: '開啟 FLIGHT 404 說明',
  close: '關閉 FLIGHT 404 說明',
} as const;
